import { createContext, useContext } from 'react';
export const TooltipContext = createContext(undefined);
export const useTooltip = () => {
    const context = useContext(TooltipContext);
    if (context === undefined) {
        throw new Error('useTooltip must be used within a TooltipProvider');
    }
    return context;
};
//# sourceMappingURL=TooltipContext.js.map